import _ from "lodash";
import moment from "moment";

import {
  SET_CUSTOM_PROPERTIES,
  CREATE_CUSTOM_PROPERTY,
  DELETE_CUSTOM_PROPERTY,
  UNSET_CUSTOM_PROPERTY_ACTION,
  UPDATE_CUSTOM_PROPERTY,
  ERROR_CUSTOM_PROPERTY,
  UNSET_ERROR_CUSTOM_PROPERTY
} from "actions/types";

const INITIAL_STATE = {
  lastAction: null,
  propertiesAvailable: {},
  propertyErrors: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_CUSTOM_PROPERTIES:
      return {
        ...state,
        lastAction: "fetch",
        propertiesAvailable: _.mapKeys(action.payload, "id")
      };
    case UNSET_CUSTOM_PROPERTY_ACTION:
      return { ...state, lastAction: null };
    case CREATE_CUSTOM_PROPERTY:
      const createdItem = action.payload.created_items[0];
      const { id } = createdItem;
      const newState = {
        ...state,
        lastAction: "create",
        propertiesAvailable: {
          ...state.propertiesAvailable,
          [id]: createdItem
        }
      };
      return newState;
    case UPDATE_CUSTOM_PROPERTY:
      const updatedItem = (state.propertiesAvailable[
        action.currentCustomProperty.id
      ] = action.currentCustomProperty);
      updatedItem.updated_at = moment.utc().format("YYYY-MM-DD HH:mm:ss");
      return {
        ...state,
        lastAction: "edit",
        updatedItem
      };
    case ERROR_CUSTOM_PROPERTY:
      return {
        ...state,
        propertyErrors: action.payload,
        lastAction: "error"
      };
    case UNSET_ERROR_CUSTOM_PROPERTY:
      return {
        ...state,
        propertyErrors: {}
      };
    case DELETE_CUSTOM_PROPERTY:
      const updated = state.propertiesAvailable;
      _.unset(updated, `${action.currentCustomProperty.id}`);
      return { ...state, lastAction: "delete", propertiesAvailable: updated };
    default:
      return state;
  }
};
